module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/notokr-medium.woff2
// module id = /42C
// module chunks = 0